import React, {useContext, useEffect, useRef, useState} from 'react';
import {CustomSelect} from 'components/CustomSelect'

import {Col, Form} from "react-bootstrap";
import {useLocation} from "react-router";
import {showAsterisk} from "../../utils/FormatUtils";
import {getSessionAttribute, setSessionAttribute} from "../../utils/SessionUtils";
import {SELECTED_ACCOUNT, SELECTED_ENTITY, ACCOUNTS_OPTIONS, LEGAL_ENTITY, ACCOUNTS_OPTIONS_NO_SWAP} from "../../utils/Constants";
import AuthenticationService from "../../service/AuthenticationService";
import {EntityAccountsContext} from "../../components/entity-accounts/context";

const AssetTransferEntityAccountsPart = (props) => {
    const {clearAccountDetails, setInitEntityAccountsOptions, entityAccountsOptionsNoSwap, accountsOptionsNoSwap, entityAccountsNoSwap, setManagerDetails, setAccountDetails, getAccountsForSelectedEntity} = useContext(EntityAccountsContext);
    const [localEntityAccountsOptions,setLocalEntityAccountsOptions] = useState(JSON.parse(JSON.stringify(entityAccountsOptionsNoSwap)))
    const [options,setOptions] = useState([])
    const [selectedOption,setSelectedOption] = useState({})
    const {entityReadOnly,accountOptional, ssaEntityWidthFull, onAccountChange} = props
    const location  = useLocation();
    const pathname = location.pathname;



    const handleAccountChange = (e) => {

        const accountId = e.target.value;
        const accountToSelect = accountsOptionsNoSwap.find(account => account.accountId.toString() === accountId);

        if(accountToSelect) {
            setAccountDetails(accountToSelect.accountId, accountToSelect.name, accountToSelect.accountCode,true);
            setSessionAttribute(LEGAL_ENTITY,accountToSelect.legalEntity)
            setSessionAttribute(SELECTED_ACCOUNT, null);
            setSessionAttribute(SELECTED_ACCOUNT, accountToSelect);
            if(!AuthenticationService.isInternalUser()){ // Currently all external users have Wire Submission unless not configured in Client Master
                onAccountChange()
            }
        }
        else{
            let firstAccountForLegalEntity = getAccountsForSelectedEntity(getSessionAttribute(SELECTED_ENTITY).managerId,true)[0]
            setSessionAttribute(SELECTED_ACCOUNT, {accountId: '', name: '', accountCode: null});
            setSessionAttribute(LEGAL_ENTITY, firstAccountForLegalEntity?.legalEntity)
            setAccountDetails('','',null,true);
        }
    }
    useEffect(() => {
        getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP) ?? setInitEntityAccountsOptions(true);
    }, []);

    useEffect(()=>{
        setLocalEntityAccountsOptions(JSON.parse(JSON.stringify(entityAccountsOptionsNoSwap)))
    },[entityAccountsOptionsNoSwap])

    useEffect(()=>{

        const options = []
        localEntityAccountsOptions.map(e=>{
            let option = {}
            option['value'] = e.managerId
            option['label'] = e.shortName+'-'+e.longName
            options.push(option)
        })
        setOptions(options)
    },[localEntityAccountsOptions])

    useEffect(() => {
        if (entityAccountsNoSwap.disableAccounts)
            clearAccountDetails(true);
    }, [entityAccountsNoSwap.disableAccounts]);

    useEffect(()=>{
        const selectedEntity = options.filter(e=>e.value===Number(entityAccountsNoSwap.managerId))
        if(selectedEntity.length>0)
        {
            setSelectedOption(selectedEntity[0]);
        }
        else{
            setSelectedOption({})
        }

    },[entityAccountsNoSwap.managerId,options])


    const handleChangeAutocomplete = (e)=>{
        setManagerDetails(e.value, e.label,true);

        let selectedEntity = {};
        selectedEntity['managerId']=e.value;
        selectedEntity['managerName']=e.label;
        setSessionAttribute(SELECTED_ENTITY,selectedEntity);
        let firstAccountForLegalEntity = getAccountsForSelectedEntity(selectedEntity['managerId'],true)[0]
        setSessionAttribute(LEGAL_ENTITY, firstAccountForLegalEntity?.legalEntity)
        setSessionAttribute(SELECTED_ACCOUNT, {accountId: '', name: '', accountCode: null});
    }
    const handleInputChangeAutoComplete = (enteredValue)=>{

        const newData = entityAccountsOptionsNoSwap.filter(e=> {
                return e.shortName.toLowerCase().includes(enteredValue.toLowerCase()) || e.longName.toLowerCase().includes(enteredValue.toLowerCase())
            }
        )
        setLocalEntityAccountsOptions(newData)

    }

    return(<>
        <Col xs={12} sm={4} md={4} xl={4} lg={4} className="pt-0">
            <Form.Group controlId="formGridEntity"   id={(!!entityAccountsNoSwap.formErrors.search.entity? 'td-select-error':'')}>
                <Form.Label className="filter-input-label">Entity <span className='red-cell'>*</span></Form.Label>
                    <CustomSelect
                        isDisabled={props.entityReadOnly ?? false}
                        placeholder={'Select'}
                        options={options}
                        value={Object.keys(selectedOption).length > 0?selectedOption:null}
                                   onChange={handleChangeAutocomplete}
                                   onInputChange={handleInputChangeAutoComplete}
                        isValid={!entityAccountsNoSwap.formErrors.search.entity}
                        className={!entityAccountsNoSwap.formErrors.search.entity?'is-invalid invalid':''}
                    />

                {!!entityAccountsNoSwap.formErrors.search.entity &&
                    <b className={'error-text'}><i className="bi bi-exclamation-circle"></i>{entityAccountsNoSwap.formErrors.search.entity}</b>
                }
            </Form.Group>
        </Col>
        {
            <Col xs={12} sm={4} md={4} xl={4} lg={4} className="pt-0">
                <Form.Group controlId="formGridAccount" className={'td-select'} id={(!!entityAccountsNoSwap.formErrors.search.account?!accountOptional?'td-select-error':'':'')}>
                    <Form.Label className="filter-input-label" >Account Number <span className='red-cell'>*</span></Form.Label>
                    <Form.Control as="select" name='accounts' value={entityAccountsNoSwap.accountId} onChange={handleAccountChange} disabled={entityAccountsNoSwap.disableAccounts}
                                  isInvalid={!!entityAccountsNoSwap.formErrors.search.account && !accountOptional} >
                        <option value={''}>Select </option>
                        {accountsOptionsNoSwap &&
                            accountsOptionsNoSwap.map((account) => <option key={account.accountId} value={account.accountId}>{account.accountCode}-{account.name} </option>)}
                    </Form.Control>
                    <Form.Control.Feedback type={'invalid'} >
                        <b><i className="bi bi-exclamation-circle"></i>{entityAccountsNoSwap.formErrors.search.account}</b>
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
        }

    </>);

};

export {AssetTransferEntityAccountsPart};

AssetTransferEntityAccountsPart.defaultProps = {
    accountOptional: false,
    ssaEntityWidthFull: false,
    entityReadOnly: false,
    onAccountChange: () => {
        console.log("Do nothing if you are not on Asset Transfers screen")
    }
}